import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { forwardRef, useContext } from 'react';
import cx from 'classnames';
import { prefix } from '../../../tools/settings';
import Button from '../../Button';
import Chip from '../../Chip';
import Icon from '../../Icon';
import Tooltip from '../../Tooltip';
import { TakeoverContext } from '../Takeover';
import { Styled } from './Header.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var useTakeoverContext = function useTakeoverContext() {
  return useContext(TakeoverContext);
};

var Header = forwardRef(function (_ref, ref) {
  var _cx, _header$title, _header$title2;

  var children = _ref.children,
      chips = _ref.chips,
      customClassName = _ref.className,
      id = _ref.id,
      meta = _ref.metadata,
      title = _ref.title;
  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-takeover__header"), true), _defineProperty(_cx, customClassName, !!customClassName), _cx));

  var _useTakeoverContext = useTakeoverContext(),
      header = _useTakeoverContext.header;

  var metadata = meta || (header === null || header === void 0 ? void 0 : header.metadata);
  var titleLabel = (title === null || title === void 0 ? void 0 : title.label) || (header === null || header === void 0 ? void 0 : (_header$title = header.title) === null || _header$title === void 0 ? void 0 : _header$title.label);
  var icons = (title === null || title === void 0 ? void 0 : title.icons) || (header === null || header === void 0 ? void 0 : (_header$title2 = header.title) === null || _header$title2 === void 0 ? void 0 : _header$title2.icons);
  var headerActions = header === null || header === void 0 ? void 0 : header.actions;
  return _jsxs(Styled.Container, {
    ref: ref,
    id: id,
    className: className,
    children: [_jsxs(Styled.Header, {
      children: [metadata && _jsx(Styled.Metadata, {
        children: metadata
      }), _jsxs(Styled.Group, {
        children: [titleLabel && _jsx(Styled.Title, {
          children: titleLabel
        }), icons && icons.map(function (item, index) {
          return _jsx(Tooltip, {
            content: item.tooltip,
            children: _jsx(Icon, {
              size: 16,
              icon: item.icon
            })
          }, index);
        }), chips && chips.map(function (chip, index) {
          return _jsx(Chip, {
            action: chip.action,
            avatar: chip.avatar,
            hasStatusLight: chip.hasStatusLight,
            icon: chip.icon,
            isDisabled: chip.isDisabled,
            isGhost: chip.isGhost,
            isSelected: chip.isSelected,
            onClick: chip.onClick,
            status: chip.status,
            variant: chip.variant,
            children: chip.label
          }, index);
        })]
      })]
    }), _jsxs(Styled.Actions, {
      children: [headerActions && headerActions.map(function (action, index) {
        var _action$iconLeft, _action$iconRight, _action$isDisabled, _action$isLoading, _action$variant;

        return _jsx(Button, {
          iconLeft: (_action$iconLeft = action === null || action === void 0 ? void 0 : action.iconLeft) !== null && _action$iconLeft !== void 0 ? _action$iconLeft : null,
          iconRight: (_action$iconRight = action === null || action === void 0 ? void 0 : action.iconRight) !== null && _action$iconRight !== void 0 ? _action$iconRight : null,
          isDisabled: (_action$isDisabled = action === null || action === void 0 ? void 0 : action.isDisabled) !== null && _action$isDisabled !== void 0 ? _action$isDisabled : false,
          isLoading: (_action$isLoading = action === null || action === void 0 ? void 0 : action.isLoading) !== null && _action$isLoading !== void 0 ? _action$isLoading : false,
          variant: (_action$variant = action === null || action === void 0 ? void 0 : action.variant) !== null && _action$variant !== void 0 ? _action$variant : 'secondary',
          onClick: action.onClick,
          children: action.label
        }, index);
      }), children]
    })]
  });
});
export default Header;